import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface PilotSlide3Props {
  isDark?: boolean;
}
export function PilotSlide3({
  isDark = false
}: PilotSlide3Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-639">
      <div className="min-h-full flex flex-col justify-start md:justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-16" data-id="element-640">
        {/* Hero Image */}
        <motion.div variants={itemVariants} className="relative mb-8 sm:mb-12" data-id="element-641">
          <div className="relative rounded-3xl overflow-hidden shadow-lg" data-id="element-642">
            <img src="https://cdn.magicpatterns.com/uploads/4zf6a3LtqQ3WuChNFQcbuL/Screenshot_2026-01-05_at_5.29.11_PM.png" alt="Team collaboration" className="w-full h-24 sm:h-40 object-cover" data-id="element-643" />
            <div className="absolute inset-0 bg-gradient-to-t from-heliona-navy/40 to-transparent" data-id="element-644"></div>
          </div>
        </motion.div>

        {/* Title Section */}
        <motion.div variants={itemVariants} className="mb-8 sm:mb-10" data-id="element-645">
          <h1 className={`text-3xl sm:text-5xl font-serif font-medium mb-3 sm:mb-4 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-646">
            The Opportunity
          </h1>
          <div className="h-1 w-full bg-gradient-to-r from-heliona-mint via-heliona-mint/50 to-transparent rounded-full" data-id="element-647"></div>
        </motion.div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-14 items-start" data-id="element-648">
          {/* Left Side - Text Content */}
          <motion.div variants={itemVariants} className="space-y-5 sm:space-y-7" data-id="element-649">
            <div className="space-y-3 sm:space-y-4" data-id="element-650">
              <p className={`leading-relaxed text-base sm:text-lg ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-651">
                <span className="font-bold text-heliona-orange" data-id="element-652">
                  Replacing a manager/leader cost 200% to 400% of the their
                  annual salary.
                </span>
              </p>
              <p className={`leading-relaxed text-sm sm:text-base ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-653">
                Heliona prevents these outcomes by supporting leaders where it
                matters most: clarity, communication, capacity, and crisis.
              </p>
            </div>

            <div className="pt-2 sm:pt-3" data-id="element-654">
              <p className={`leading-relaxed text-sm sm:text-base ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-655">
                Our{' '}
                <span className={`font-semibold ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-656">
                  60-90-day pilot
                </span>{' '}
                offers a first-hand experience of how Heliona improves
                organizational health by empowering leaders across every level.
                From founders, presidents, chief officers, EVPs, SVPs, directors
                to managers with personalized insights, wellness tools, and
                leadership development resources.
              </p>
            </div>
          </motion.div>

          {/* Right Side - Platform Screenshot */}
          <motion.div variants={itemVariants} className="relative mb-16 sm:mb-0" data-id="element-657">
            <div className={`relative rounded-3xl overflow-hidden shadow-lg border ${isDark ? 'border-white/10 bg-white/5' : 'border-heliona-beige bg-white'}`} data-id="element-658">
              <img src="https://cdn.magicpatterns.com/uploads/1e54r7Vra6fUEKfwC3aa9Z/Look_into_the_platform_screenshot.png" alt="Heliona Platform Dashboard" className="w-full" data-id="element-659" />
              <div className="absolute inset-0 bg-gradient-to-t from-heliona-navy/20 to-transparent pointer-events-none" data-id="element-660"></div>
            </div>
            <p className={`text-xs sm:text-sm text-center mt-3 sm:mt-4 italic ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-661">
              A look into the Heliona platform
            </p>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}